module.exports = __webpack_public_path__ + "static/media/info.3cb059a3.svg";